import type { InvestmentComplianceLimitDataLevelOptionsDtoResponse } from '@asset-metrix/portal-gateway-client-js';

import { extractErrorMessage } from '../../utils/errorMessage';
import { HttpError } from '../errors';
import { portalGatewayClient } from '../portalGatewayClient';

export const getInvestmentComplianceLimitOptions = async (
  contentId: string,
  dataLevelIndex: number
): Promise<InvestmentComplianceLimitDataLevelOptionsDtoResponse> => {
  const response =
    await portalGatewayClient.table.getInvestmentComplianceLimitOptions(
      contentId,
      String(dataLevelIndex)
    );

  if (!response.ok) {
    throw new HttpError(
      extractErrorMessage(
        response.error,
        'Error loading investment compliance limit options.'
      ),
      response
    );
  }

  return response.data;
};
